<template>
  <v-card>
    <v-toolbar flat color="#7C3DFF">
      <v-toolbar-title class="m-0 white--text">Regras de Split</v-toolbar-title>
      <v-spacer />
      <v-btn
        color="pink lighten-1"
        @click.prevent="openSplitForm()"
        dark
        class="mb-2"
        >Adicionar</v-btn
      >
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="splits"
      no-data-text="Usina não possui splits"
      :search="search"
      :pagination.sync="pag"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.partner }}</td>
        <td class="text-xs-center">
          {{ props.item.recipient_id ? props.item.recipient_id : "" }}
        </td>
        <td class="text-xs-center">
          {{
            props.item.bank_account
              ? props.item.bank_account.document_type.toUpperCase() +
                ": " +
                props.item.bank_account.document_number
              : ""
          }}
        </td>
        <td class="text-xs-center">
          {{ props.item.bank_account ? props.item.bank_account.bank_code : "" }}
        </td>
        <td class="text-xs-center">
          {{
            props.item.bank_account
              ? props.item.bank_account.agencia +
                (props.item.bank_account.agencia_dv
                  ? "-" + props.item.bank_account.agencia_dv
                  : "")
              : ""
          }}
        </td>
        <td class="text-xs-center">
          {{
            props.item.bank_account
              ? props.item.bank_account.conta +
                "-" +
                props.item.bank_account.conta_dv
              : ""
          }}
        </td>
        <td class="text-xs-center">{{ props.item.percentage }}%</td>
        <td class="text-xs-center">{{ props.item.liable | BooleanFilter }}</td>
        <td class="text-xs-center">
          {{ props.item.charge_processing_fee | BooleanFilter }}
        </td>
        <td class="text-xs-center">
          <v-btn
            flat
            icon
            color="error"
            @click="openDeleteSplitDialog(props.item.recipient_id)"
            :disabled="loading"
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </td>
      </template>
      <template v-slot:no-data>
        <div class="text-xs-center" v-if="loading">
          <v-progress-circular
            indeterminate
            color="#7C3DFF"
          ></v-progress-circular>
        </div>
      </template>
    </v-data-table>

    <v-dialog v-model="deleteSplitDialog" max-width="290" dark>
      <v-card color="#7C3DFF">
        <v-card-title class="headline"
          >Tem certeza que deseja deletar esse split?</v-card-title
        >
        <v-card-actions>
          <v-spacer />
          <v-btn color="red" @click="deleteSplitDialog = false" dark>
            Não
          </v-btn>
          <v-btn color="green" dark @click="deleteSplit()"> Sim </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <split-form
      :key="splitFormKey"
      :powerPlantId="powerPlantId"
      :split="split"
    />
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import SplitForm from "./SplitForm.vue";

export default {
  props: {
    powerPlantId: {
      type: String,
      default: null,
    },
    split: {
      type: Array,
      default: () => [],
    },
  },

  components: { SplitForm },

  data: () => ({
    search: "",
    valid: false,
    dialog: false,
    deleteSplitDialog: false,
    recipientId: null,
    splitFormKey: 0,
    headers: [
      { text: "Parceiro", align: "center", value: "partner" },
      { text: "ID do Recebedor", align: "center", value: "recipient_id" },
      { text: "Número do Documento", align: "center", value: "cnpj_cpf" },
      { text: "Número do Banco", align: "center", value: "bank_number" },
      { text: "Agência", align: "center", value: "agency_number" },
      { text: "Conta", align: "center", value: "account_number" },
      { text: "Porcentagem", align: "center", value: "percentage" },
      { text: "Assume Charback", align: "center", value: "liable" },
      {
        text: "Taxas de Transação",
        align: "center",
        value: "charge_processing_fee",
      },
      { text: "Ações", align: "center", value: "actions" },
    ],
    pag: {
      rowsPerPage: 10,
    },
  }),

  computed: {
    ...mapState("configuration", ["loading", "splits"]),
  },

  methods: {
    ...mapActions("configuration", ["getSplits", "changeSplit"]),
    ...mapMutations("configuration", ["setLoading", "setSplitDialog"]),

    openDeleteSplitDialog(recipientId) {
      this.recipientId = recipientId;
      this.deleteSplitDialog = true;
    },

    deleteSplit() {
      const newSplit = this.split.filter(
        (item) => item.recipient_id !== this.recipientId,
      );
      this.changeSplit({
        powerPlantId: this.powerPlantId,
        recipientId: this.recipientId,
        split: newSplit,
      });
      this.deleteSplitDialog = false;
    },

    openSplitForm() {
      this.splitFormKey++;
      this.setSplitDialog(true);
    },
  },

  filters: {
    BooleanFilter(value) {
      if (value) return "Sim";
      else return "Não";
    },
  },

  async mounted() {
    this.setLoading(true);
    await this.getSplits(this.split);
    this.setLoading(false);
  },
};
</script>
